// Marketplace - Care Providers

export interface ShortlistItemAddress {
  streetAddress1?: string;
  streetAddress2?: string;
  city: string;
  county: string;
  postcode: string;
}

export interface ShortlistItemGeoPoint {
  lat: number;
  lon: number;
}

export interface ShortlistItemRatingDetail {
  caring: string;
  effective: string;
  responsive: string;
  safe: string;
  wellLed: string;
}

export interface ShortlistItemRating {
  overallRating: string;
  inspectionDate?: string;
  ratings?: ShortlistItemRatingDetail;
}

export interface ShortlistItemPhoto {
  large: string;
  medium: string;
  small: string;
  tiny: string;
}

export interface ShortlistItemCareServiceType {
  id: number;
  name: string;
}

export interface ShortlistItemProvider {
  regulatoryId: string;
  name: string;
  careType: string;
  address: ShortlistItemAddress;
  location: ShortlistItemGeoPoint;
  distanceMiles?: number | null;
  rating: ShortlistItemRating;
  pricePerWeek?: number | null;
  enquiryPhone?: string | null;
  enquiryEmail?: string | null;
  bedCount?: number | null;
  photos: ShortlistItemPhoto[];
  careServiceTypes: ShortlistItemCareServiceType[];
  description?: string | null;
  specialisms?: string[];
  url?: string | null;
  managerName?: string | null;
  fundings?: { name: string }[];
  enSuiteRoomCount?: number | null;
  purposeBuilt?: boolean | null;
  doubleBedCount?: number | null;
  dateOpened?: string | null;
  isPremium?: boolean | null;
}

// Shortlists

export const SHORTLIST_ITEM_STATUS = {
  NOT_CONTACTED: 'not_contacted',
  CONTACTED: 'contacted',
  SECURED: 'secured',
  UNAVAILABLE: 'unavailable',
} as const;

export type ShortlistItemStatus =
  (typeof SHORTLIST_ITEM_STATUS)[keyof typeof SHORTLIST_ITEM_STATUS];

export interface ShortlistItem {
  regulatoryId: string;
  position: number;
  note?: string;
  status: ShortlistItemStatus;
  dismissed?: boolean;
  dismissReason?: string;
  dismissDetail?: string;
  provider: ShortlistItemProvider;
  providerMissing: boolean;
  createdAt: string;
  updatedAt: string;
  securedAt?: string;
}
